import "babel-polyfill"; // Needed for redux-saga es6 generator support
import "raf/polyfill";
import { AppContainer } from "react-hot-loader";
// Import all the third party stuff
import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
import { GlobalStyle } from "./theme/index";
import { ThemeProvider } from "styled-components";
import { BaseTheme } from "genbook-components";

import "sanitize.css/sanitize.css";
import "semantic-ui-css/semantic.min.css";

import App from "./containers/app";
import LanguageProvider from "./components/shared/language-provider/centerPanel";

import "./manifest.json";
import "./calendar-integration/main.calendar.js";
//import './assets/images/favicon.ico';
import "!file-loader?name=[name].[ext]!./assets/images/icon-72x72.png";
import "!file-loader?name=[name].[ext]!./assets/images/icon-96x96.png";
import "!file-loader?name=[name].[ext]!./assets/images/icon-128x128.png";
import "!file-loader?name=[name].[ext]!./assets/images/icon-144x144.png";
import "!file-loader?name=[name].[ext]!./assets/images/icon-152x152.png";
import "!file-loader?name=[name].[ext]!./assets/images/icon-192x192.png";
import "!file-loader?name=[name].[ext]!./assets/images/icon-384x384.png";
import "!file-loader?name=[name].[ext]!./assets/images/icon-512x512.png";

import configureStore from "./configureStore";
import { initialState } from "./state/initialState";

import "./style/main.scss";
import "whatwg-fetch";
import "custom-event-polyfill";
import "./components/shared/functions/polyfills";
require("es6-promise").polyfill();

const DEFAULT_LOCALE = "en";

window.logger = require("logdown")("calendar-spa-booking");

if (process && process.env.NODE_DEBUG) {
  window.logger.state.isEnabled = true;
}
import { translationMessages } from "./i18n";

const history = createHistory();
let store = configureStore(initialState, history); // Create redux store with history
window.store = store;
window.dispatch = store.dispatch;

window.calculateAllImportantinformationFromStore = () => {
  return (
    JSON.stringify(store.getState().appointmentCheckoutReducer) +
    JSON.stringify(store.getState().appointmentStepReducer) +
    JSON.stringify(store.getState().customerProfileReducer) +
    JSON.stringify(store.getState().advancedAppointmentStepReducer)
  );
};

const Theme = {
  ...BaseTheme,
  color: {
    ...BaseTheme.color
  }
};

export const appWrapper = (NextApp, messages, injectedStore) => {
  if (injectedStore) {
    store = configureStore(injectedStore, history); // Create redux store with history
  }

  return (
    <AppContainer>
      <Provider store={store}>
        <ThemeProvider theme={Theme}>
          <React.Fragment>
            <GlobalStyle />
            <LanguageProvider messages={messages}>
              <ConnectedRouter history={history}>
                <NextApp />
              </ConnectedRouter>
            </LanguageProvider>
          </React.Fragment>
        </ThemeProvider>
      </Provider>
    </AppContainer>
  );
};

import "./config.js";
window.APP.LANGUAGE = require("./state/translations/" +
  DEFAULT_LOCALE +
  ".json");

export const launchApp = (render, injectedStore) => {
  // Chunked polyfill for browsers without Intl support
  if (!window.Intl) {
    new Promise(resolve => {
      resolve(import("intl"));
    })
      .then(() => Promise.all([import("intl/locale-data/jsonp/en.js")]))
      .then(() => {
        if (module.hot) {
          module.hot.accept("containers/app", () => {
            const NextApp = require("containers/app").default;

            render(NextApp, translationMessages, injectedStore);
          });
          render(App, translationMessages, injectedStore);
        } else {
          render(App, translationMessages, injectedStore);
        }
      })
      .catch(err => {
        throw err;
      });
    //   require.ensure([
    //     'intl',
    //     'intl/locale-data/jsonp/en.js'
    // ], function (require) {
    //     require('intl');
    //     require('intl/locale-data/jsonp/en.js');
    //     runMyApp()
    // });
  } else {
    if (module.hot) {
      module.hot.accept("containers/app", () => {
        const NextApp = require("containers/app").default;
        render(NextApp, translationMessages);
      });
      render(App, translationMessages, injectedStore);
    } else {
      render(App, translationMessages, injectedStore);
    }
  }
};
